import React from "react";
import { useCallback } from "react";
import { useDatalayerModalPush } from "../hooks/use-datalayer-modal-push";

type Props = React.HTMLAttributes<HTMLButtonElement> & {
    children?: React.ReactNode;
    label: string;
    onClick?: VoidFunction;
    as?: React.ElementType<
        React.HTMLAttributes<HTMLButtonElement> & {
            onClick: (payload: any) => void;
            children: React.ReactNode;
        }
    >;
};

export const DatalayerModalButton: React.FC<Props> = (props: Props) => {
    const {
        label,
        children,
        onClick,
        as: Component = "button",
        ...rest
    } = props;
    const { push } = useDatalayerModalPush();
    const internalOnClick = useCallback(() => {
        push(`Seleccionar: ${label}`);
        onClick && onClick();
    }, []);
    return (
        <Component
            data-testid="DatalayerModalButton"
            onClick={internalOnClick}
            {...rest}
        >
            {children}
        </Component>
    );
};
